import { render } from "./detail.vue?vue&type=template&id=a48c96fc&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=a48c96fc&scoped=true&lang=scss"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a48c96fc"],['__file',"resources/js/pages/message/detail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a48c96fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a48c96fc', __exports__)) {
    console.log('reload')
    api.reload('a48c96fc', __exports__)
  }
  
  module.hot.accept("./detail.vue?vue&type=template&id=a48c96fc&scoped=true", () => {
    console.log('re-render')
    api.rerender('a48c96fc', render)
  })

}


export default __exports__